import {
  MitoVault,
  TokenType,
  TokenStatic,
  TokenVerification
} from '@injectivelabs/sdk-ts'
import { UiMarket, VaultContractType } from '@/types'

export const getDefaultTokenMeta = ({
  denom,
  market,
  isOffChain,
  vaultName = ''
}: {
  denom?: string
  market: UiMarket
  vaultName?: string
  isOffChain?: boolean
}): TokenStatic => {
  const symbol = isOffChain
    ? vaultName
        .replaceAll('/', '-')
        .replaceAll(' ', '-')
        .replace('Offchain', 'OC')
    : `${market.baseToken.symbol}-${market.quoteToken.symbol} LP`

  return {
    symbol,
    denom: denom || '',
    address: denom || '',
    name: vaultName || '',
    logo: 'mito-inj-master-lp.svg',
    decimals: 18,
    coinGeckoId: '',
    tokenType: TokenType.Cw20,
    tokenVerification: TokenVerification.Internal
  }
}

export const getVaultName = ({
  vault,
  market,
  vaultType
}: {
  vault: MitoVault
  market: UiMarket
  vaultType: VaultContractType
}): string => {
  if (vaultType === VaultContractType.OffChain) {
    return vault.vaultName
  }

  return market.ticker
}

export const getLpDenom = (vault: MitoVault): string => {
  return vault.vaultType === VaultContractType.OffChain
    ? `factory/${vault.contractAddress}/lp`
    : `factory/${vault.masterContractAddress}/lp${vault.contractAddress}`
}
